const CUSTOM_COLOR_SCHEME_DEFAULT_COLOR_BACKGROUND = '#FFFFFF';
const CUSTOM_COLOR_SCHEME_DEFAULT_COLOR_GRID = '#CCCCCC';
const CUSTOM_COLOR_SCHEME_DEFAULT_COLOR_TEXT = '#000000';
const CUSTOM_COLOR_SCHEME_DEFAULT_COLOR_INDICATOR = '#333333';

export {
  CUSTOM_COLOR_SCHEME_DEFAULT_COLOR_BACKGROUND,
  CUSTOM_COLOR_SCHEME_DEFAULT_COLOR_GRID,
  CUSTOM_COLOR_SCHEME_DEFAULT_COLOR_TEXT,
  CUSTOM_COLOR_SCHEME_DEFAULT_COLOR_INDICATOR
};
